// extracted by mini-css-extract-plugin
module.exports = {"container":"MyBrandListEmptyState_container__2lxA-","tips":"MyBrandListEmptyState_tips__2Ad_f"};